const url = '/supplierservices';
const Provider = 'SupplierService';
const dbModel = 'SupplierService';

export { url, Provider, dbModel };
